import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedAdmin = ({ children }) => {
    const token = Cookies.get('token'); 
    const userData = JSON.parse(window.localStorage.getItem("userData"));

    if (!token || !userData || !userData.role || userData.role.name !== 'Admin') {
        window.alert("You do not have access to this page");
        return <Navigate to="/login" />;
    }

    return children;
};

export default ProtectedAdmin;
